import React from "react";
import "./App.css";
import controls from "./controls.json";
import { Outlet } from "react-router-dom";
import { Nav, Container } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

function App() {
  return (
    <Container>
      <h1>
        <a href="/" className="text-body" style={{ textDecoration: "none" }}>
          NIST 800-53 Rev. 5
        </a>
      </h1>
      <Nav variant="tabs">
        {controls.map((family) => {
          return (
            <Nav.Item key={family.Family}>
              <LinkContainer to={family.Family}>
                <Nav.Link>{family.Family}</Nav.Link>
              </LinkContainer>
            </Nav.Item>
          );
        })}
      </Nav>

      <Outlet />
    </Container>
  );
}

export default App;
